/* 🤖 this file was generated by svg-to-ts */
export const matIconDateRange: {
  name: 'date-range';
  data: string;
} = {
  name: 'date-range',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z"/></svg>`
};
